function getAnalyticsHost() {
  const hostname = window.location.hostname.replace(/^viewer\./, '')
  return window.location.protocol + '//analytics.' + hostname
}

function getViewerId() {
  let id = localStorage.getItem('sw_analytics_id')
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36)
    localStorage.setItem('sw_analytics_id', id)
  }
  return id
}

export function trackActivity(type, metadata) {
  const url = getAnalyticsHost() + '/api/analytics/activity'
  const body = JSON.stringify({ viewerId: getViewerId(), type, metadata })

  const controller = new AbortController()
  setTimeout(() => controller.abort(), 5000)

  fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body,
    signal: controller.signal
  }).catch(function() {})
}

export function initActivityTracking() {
  const originalFetch = window.fetch
  window.fetch = function() {
    const args = Array.prototype.slice.call(arguments)
    const url = typeof args[0] === 'string' ? args[0] : ''
    const options = args[1] || {}

    if (url.includes('/project/save-matrix') && options.method === 'POST') {
      trackActivity('save_version')
    }
    if (url.includes('/project/update-note') && options.method === 'POST') {
      trackActivity('add_note')
    }

    return originalFetch.apply(this, args)
  }
}
